import apiClient from "./axios"
import { downloadAndOpenFile } from "./pdfApi"

export const getAccountRtgsPayments = async (params = {}) => {
  const { data } = await apiClient.get("/account-rtgs-payments", { params })
  return data
}

export const getAccountRtgsPayment = async id => {
  const { data } = await apiClient.get(`/account-rtgs-payments/${id}`)
  return data
}

export const createAccountRtgsPayment = async payload => {
  const { data } = await apiClient.post("/account-rtgs-payments", payload)
  return data
}

export const updateAccountRtgsPayment = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/account-rtgs-payments/${id}`, payload)
  return data
}

export const deleteAccountRtgsPayment = async id => {
  const { data } = await apiClient.delete(`/account-rtgs-payments/${id}`)
  return data
}

export const completeAccountRtgsPayment = async id => {
  const { data } = await apiClient.post(`/account-rtgs-payments/${id}/complete`)
  return data
}

export const downloadRtgsPdf = async (
  id,
  { withPad = true, part1 = true, part2 = true, amount = true, printDate, onStart, onEnd } = {}
) => {
  const params = {
    with_pad: withPad ? 1 : 0,
    part1: part1 ? 1 : 0,
    part2: part2 ? 1 : 0,
    amount: amount ? 1 : 0,
  }
  // printDate: omit -> backend uses stored date; "" -> blank date; "YYYY-MM-DD" -> that date
  if (printDate !== undefined) params.print_date = printDate
  await downloadAndOpenFile({
    url: `/account-rtgs-payments/${id}/pdf`,
    params,
    openInNewTab: true,
    onStart,
    onEnd,
  })
}

export const downloadRtgsPrint = async (id, { onStart, onEnd } = {}) => {
  await downloadAndOpenFile({
    url: `/account-rtgs-payments/${id}/print`,
    openInNewTab: true,
    onStart,
    onEnd,
  })
}
